import { ContainerBody } from "../../App";
import "./index.css";
import OverviewSection from "./OverviewSection.js";

const Row = ({ title }) => {
  return (
    <div className="d-flex mb-2 my-2" style={{ color: "#F2F8F0" }}>
      <div className="bg__box1 p-3 my-auto w-20 h-100 d-flex align-items-center justify-content-center">
        <h5 className="text-center my-auto">{title}</h5>
      </div>
      <div className="bg__box1 p-5 my-auto w-80 mx-4">
        <h5>
          YFS is about sharing and understanding what our common purpose and
          responsibilities are. As a tool YFS makes a great and complex task
          managable
        </h5>
      </div>
    </div>
  );
};

const AboutYFS = () => {
  return (
    <ContainerBody className="about__body mb-10">
      <OverviewSection />
      {/* <SecondWord/>
            <ThirdWord/>
            <FourthWord/> */}
      {/* <Row title={"Mission"}/>
            <Row title={"Vision"}/>
            <Row title={"History"}/> */}
    </ContainerBody>
  );
};

export default AboutYFS;
